import {
  PaymentMethod,
  PaymentMethodAuthRequest,
} from "store/paymentMethods/paymentMethods-state";
import { getCardName, getWalletName, maskString, typeMapper } from "./utils";

export const parsePaymentMethod = (single: PaymentMethod) => {
  let title = single.paymentMethodName ? single.paymentMethodName : "";
  let bankName = `${single.bankName}`;

  if (!title && single?.bankAccountType) {
    title = `${bankName} ${single.bankAccountType
      ? typeMapper(single.bankAccountType, "accountReverse") + " acc."
      : ""
      }`;
  }
  let detailLine = "";
  if (single.paymentMethodType === 1 && single.bankAccountType) {
    detailLine = `${bankName} ${typeMapper(
      single.bankAccountType,
      "accountReverse"
    )} Account ${single?.accountNumber ? maskString(single.accountNumber) : ""
      }`;
  } else if (single.paymentMethodType === 2) {
    bankName = getCardName(single.cardType!);
    detailLine = `${bankName} Card ending in ${single?.lastFour ? single?.lastFour : ""
      }`;
  } else if (single.paymentMethodType === 3) {
    let walletCardType = single.cardType ? getCardName(single.cardType) : "";
    if (!walletCardType) {
      walletCardType = "Card";
    }
    bankName = getWalletName(single.walletType!);
    detailLine = `${bankName} ${walletCardType} ending in ${single?.tokenizedCardData ? maskString(single.tokenizedCardData) : ""
      }`;
  }
  return {
    title,
    bankName,
    detailLine,
  };
};

export const preparePaymentMethodAuthRequest = (
  currentMethod?: PaymentMethod,
  clientId?: number | null
): PaymentMethodAuthRequest => {
  return {
    paymentMethodAuthCardDto: currentMethod?.tokenizedCardData
      ? {
        cardHolderName: currentMethod?.cardHolderName
          ? currentMethod?.cardHolderName
          : "",
        cardToken: currentMethod?.tokenizedCardData
          ? currentMethod?.tokenizedCardData
          : "",
        expirationDate: currentMethod?.expirationDate
          ? currentMethod.expirationDate
          : "",
        cvv2: currentMethod?.cvv2 || "",
        cardType: currentMethod?.cardType,
        address: {
          line1: currentMethod?.address?.line1
            ? currentMethod?.address?.line1
            : "",
          line2: currentMethod?.address?.line2,
          city: currentMethod?.address?.city,
          state: currentMethod?.address?.state,
          country: currentMethod?.address?.country,
          zip: currentMethod?.address?.zip ? currentMethod?.address?.zip : "",
        },
        lastFour: currentMethod?.lastFour,
      }
      : undefined,
    paymentMethodAuthAchDto: currentMethod?.accountNumber
      ? {
        routingNumber: currentMethod.routingNumber
          ? currentMethod.routingNumber
          : "",
        accountNumber: currentMethod.accountNumber
          ? currentMethod.accountNumber
          : "",
      }
      : undefined,
    authReferenceId: currentMethod?.authReferenceId,
    clientId: clientId || 0,
  };
};
